import { factory, getResponseCamelization } from '@repo-level/core-front';
import { buildCmsUrl, getResponseCMS } from 'api/cms/base';
import { getLocalizedPath } from '../helpers';

interface ISeoMetadataResponse {
  path: string;
  locale: string;
  title?: string;
  description?: string;
}

export interface ISeoMetadata {
  title?: string;
  description?: string;
}

const fetchSeoMetadata = factory(
  (r) => (routePath: string) =>
    r<ISeoMetadataResponse[]>(
      'get',
      buildCmsUrl({
        path: 'seo-metadatas',
        additionalParams: {
          'filters[path][$eq]': routePath,
        },
      }),
      undefined,
      { transformResponse: [getResponseCamelization(), getResponseCMS] }
    )
);

export const getSeoMetadata = async (
  locale: string,
  routePath: string
): Promise<ISeoMetadata | undefined> => {
  try {
    const fullPath = getLocalizedPath(locale, routePath);

    const response = await fetchSeoMetadata(fullPath);
    const data = response.data?.[0];

    if (!data) return;

    return {
      title: data.title,
      description: data.description,
    };
  } catch (error) {
    console.error('SEO metadata fetch error:', error);
  }
};
